import block from './block.json';

export const tagThemeAttributes = {
	backgroundColor: '@tokens.colors.neutral-000.value',
	exclusive: '@tokens.colors.highlight.value',
	alert: '@tokens.colors.brand-2-base.value',
	color: '@tokens.colors.neutral-900.value',
	typography: '@tokens.typographies.caption',
	textAlignment: 'left',
};

export const TagThemeControls: ThemeControlsType = {
	// name of the block
	title: block.title,

	// slug of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: tagThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
